export enum CommonErrors {
  number = "Not a number",
  invalidYear = "Invalid year",
  requiredField = "This field is required",
  emailFormat = "Check Email format",
  wrongUrlFormat = "Check URL format",
}
